import { matchPath } from "react-router";
import { OLD_TAX_DOCUMENTS_PATH } from "../../TaxDocumentsOld/paths";
import { TAX_DOCUMENTS_PATH } from "../paths";
import { getDefaultTaxYear, TaxYear } from "../../../shared/constants/taxYear";

export const getCurrentTaxDocumentsYear = (
  currentPathname?: string
): TaxYear => {
  const defaultTaxYear = getDefaultTaxYear();

  const pathname = currentPathname || window.location.pathname;

  if (pathname.startsWith(OLD_TAX_DOCUMENTS_PATH)) {
    return 2023 as TaxYear;
  }

  const matched = matchPath<{ year?: string }>(pathname, {
    path: TAX_DOCUMENTS_PATH
  });

  const currentYear = Number(matched?.params.year) || defaultTaxYear;

  return currentYear as TaxYear;
};
